module.exports = __webpack_public_path__ + "img/7-virtual-office.9671ca37.png";